import parse from 'html-react-parser';
import styled from '@emotion/styled';

import { rem } from '@app/styles/theme/layout';

import { stripHTML } from '../helpers/shop';

export enum ParsedContentFormat {
  PlainText = 'plain-text',
  ParseReact = 'parse-react',
}

const ParsedContent = ({
  format = ParsedContentFormat.PlainText,
  children,
}: {
  format?: ParsedContentFormat;
  children: React.ReactNode;
}) => {
  if (typeof children !== 'string') return <>{children}</>;

  return format === ParsedContentFormat.ParseReact ? (
    <ParsedContainer>{parse(children)}</ParsedContainer>
  ) : (
    <>{stripHTML(children)}</>
  );
};

export default ParsedContent;

const ParsedContainer = styled.span`
  & p {
    margin: 0;

    &:not(:last-child) {
      margin-bottom: ${rem(4)};
    }
  }
`;
